// Left.js
import React from 'react';
import { Menu } from 'antd';

import FrameUtils from './FrameUtils';
import Widget from '../widget/Widget';
import Config from '../config//Config';
import EventBus from './eventBus'
import WidgetAjax from '../widget/WidgetAjax';
// import 'antd/dist/antd.css';

import { info } from 'sass';


let path = Config.getBasePath();
class Left extends React.Component {
	constructor(props) {
		super();

		this.state = {
			// 第一次加载的时候，Widget.getSessionStorage('_left_node_openKey_')为null
			openKey: [], //控制菜单的展开
			activeKey: props.activeKey ? props.activeKey : [],
			MessageTotal: 0,
			preOpenKey: []
		};

		this.findOpenKey = this.findOpenKey.bind(this);
		this.findNode = this.findNode.bind(this);

		this.handleSelect = this.handleSelect.bind(this);
		this.setActiveKey = this.setActiveKey.bind(this);
		this.findFirstNode = this.findFirstNode.bind(this);
		this.intervalId = null;
	}

	/**
	 * 处置子菜单的选择
	 * @param {*} nodeKey 
	 */
	handleSelect(item) {

		let { openKey } = this.state

		let keyPath = [];

		this.findOpenKey(openKey, this.props.leftNode, item.key);

		Widget.addSessionStorage("_left_node_activeKey_", item.key);

		this.setState({ activeKey: item.key });

		keyPath.push(...item.keyPath);

		keyPath.reverse();

		if (this.props.leftOnSelect !== undefined) {
			this.props.leftOnSelect(item.key, item.item.props.path, keyPath);
		}
	}

	/**
	 * 菜单点击触发事件
	 * @param {*} item 
	 * @param {*} key 
	 * @param {*} keyPath 
	 * @param {*} domEvent 
	 */
	handleClick = (item, key, keyPath, domEvent) => {


		let { openKey } = this.state

		if (keyPath === undefined || keyPath === null) {
			keyPath = [];
		}

		this.findOpenKey(openKey, this.props.leftNode, item.key);

		Widget.addSessionStorage("_left_node_activeKey_", item.key);

		this.setState({ activeKey: item.key });

		// keyPath.push(...item.keyPath);

		// keyPath.reverse();

		if (this.props.leftOnSelect !== undefined) {
			this.props.leftOnSelect(item.key, item.path, keyPath);
		}
	}

	/**
	 * 展开跳转判断( 处理父级菜单的选择)
	 * @param {*} values 
	 */
	handleOpenChange = (values) => {
		console.log(values);

		let { openKey, preOpenKey } = this.state

		let keyPath = [], nodeKey;

		for (let key of values) {
			let isExist = false;
			for (let openItem of preOpenKey) {
				if (key === openItem) {
					isExist = true;
				}
			}

			if (isExist === false) {
				nodeKey = key;
				break;
			}
		}

		if (nodeKey === undefined) {
			for (let preOpenItem of preOpenKey) {
				let isExist = false;

				for (let key of values) {
					if (preOpenItem === key) {
						isExist = true;
					}

				}

				if (isExist === false) {
					nodeKey = preOpenItem;
					break;
				}
			}
		}

		let item = this.findNode(nodeKey, this.props.leftNode);

		this.findOpenKey(openKey, this.props.leftNode, item.name);

		Widget.addSessionStorage("_left_node_activeKey_", item.name);

		this.setState({ activeKey: item.name, openKey: openKey, preOpenKey: values });
		if (item && item.children) {
			console.log(item.children[0], 'item.children[0]');
			this.setState({ activeKey: item.children[0].name });

			if (this.props.leftOnSelect !== undefined) {

				this.props.leftOnSelect(item.children[0].name, item.children[0].path, keyPath);
			}
		} else {
			if (item.path !== undefined) {
				if (item.keyPath !== undefined) {
					keyPath.push(...item.keyPath);

					keyPath.reverse();
				}


			}
			if (this.props.leftOnSelect !== undefined) {
				this.props.leftOnSelect(item.name, item.path, keyPath);
			}
		}



	}

	setActiveKey(key) {
		let openKey = [];
		// let {openKey}=this.state

		this.findOpenKey(openKey, this.props.leftNode, key);

		// this.findOpenKey(openKey, this.props.disposalData, key);

		this.setState({
			activeKey: key,
			openKey: openKey,
			isState: true
		});

		Widget.addSessionStorage("_left_node_activeKey_", key);
		Widget.addSessionStorage("_left_node_openKey_", openKey);
	}

	/**
	 * 找到第一个节点
	 * @param {*} leftNode 
	 * @returns 
	 */
	findFirstNode(leftNode) {
		for (let i = 0; i < leftNode.length; i++) {
			if (leftNode[i].path !== undefined && leftNode[i].path !== null && leftNode[i].path !== "") {
				return leftNode[i];
			}

			if (leftNode[i].children !== undefined) {
				return this.findFirstNode(leftNode[i].children);
			}
		}
	}

	/**
	 * 根据节点key找到相应的节点
	 * @param {*} nodeKey 
	 * @param {*} leftNode 
	 */
	findNode(nodeKey, leftNode) {
		let node = null;

		if (leftNode !== undefined && leftNode !== null) {
			for (let i = 0; i < leftNode.length; i++) {
				// 查父级
				if (leftNode[i].name === nodeKey) {
					node = leftNode[i];
				}
				//  若父级未找到，查子集
				if (node === null && leftNode[i].children !== undefined) {
					node = this.findNode(nodeKey, leftNode[i].children);
				}

				if (node !== null) {
					break;
				}
			}
		}

		return node;
	}

	/**
	 * 根据点击节点找到需要展开的节点的key
	 * @param {*} leftNode 
	 * @param {*} activeKey 
	 */
	findOpenKey(openKey, leftNode, activeKey) {
		let isFind = false;

		if (leftNode !== undefined && leftNode !== null) {
			for (let i = 0; i < leftNode.length; i++) {
				// 查父级
				if (leftNode[i].name === activeKey) {
					isFind = true;
				}
				//  若父级未找到，查子集
				if (isFind === false && leftNode[i].children !== undefined) {
					isFind = this.findOpenKey(openKey, leftNode[i].children, activeKey);
				}

				if (isFind === true) {
					openKey.push(leftNode[i].name);
					break;
				}
			}
		}

		return isFind;
	}

	/**
	 * 创建菜单数据
	 * @param {*} nodes 
	 */
	buildMenuItems = (nodes) => {

		return FrameUtils.buildMenuItems(nodes);

	}

	buildOpenKey = (openKey, leftNode, activeKey) => {

		if (openKey === undefined || openKey === null || openKey.length === 0) {
			let sessionOpenKey = Widget.getSessionStorage("_left_node_openKey_");

			if (sessionOpenKey !== undefined && sessionOpenKey !== null && sessionOpenKey !== "") {
				openKey = JSON.parse(sessionOpenKey);
			}
		}

		if (openKey === undefined || openKey === null || openKey.length === 0) {

			if (activeKey != undefined) {
				this.findOpenKey(openKey, leftNode, activeKey);
			}
			else {
				if (leftNode !== undefined && leftNode.length > 0) {
					let node = this.findFirstNode(leftNode);

					activeKey = node.name;

					this.findOpenKey(openKey, leftNode, activeKey);
				}
			}
		}
	}

	componentDidMount() {
		let { openKey, activeKey } = this.state;
		this.enterpriseInfo();
		let nextPath = this.props.location.pathname && this.props.location.pathname.slice(6).split(',');
		activeKey = this.props.leftActiveKey || nextPath;

		this.buildOpenKey(openKey, this.props.leftNode, activeKey)

		this.setState({ activeKey: activeKey, openKey: openKey })


	}


	/**
	* 消息数据
	*/
	messageData = () => {
		const { } = this.state;
		const onLoadData = (res) => {
			if (res.status === 0) {
				this.setState({ MessageTotal: res.total });
				// EventBus.emit('bodyDataChanged', "未读更新");
			}
		}
		WidgetAjax.ajax({ url: path + "/message/list", params: { page: 1, records: 10, states: [0] }, callback: onLoadData });
	}


	/**
	 * 公司详情
	 */
	enterpriseInfo = () => {
		const onEnterpriseInfo = (res) => {
			if (res.status == 0) {
				this.setState({ info: res.result });
			}
		}
		WidgetAjax.ajax({ url: path + "/enterprise/info", callback: onEnterpriseInfo });
	}


	componentWillMount() {
		let menuItems = this.buildMenuItems(this.props.leftNode);
		this.messageData();
		this.setState({ menuItems: menuItems });

		EventBus.on('bodyDataChanged', this.handleBodyDataChange);
		// 在组件卸载时，取消订阅事件，避免内存泄漏
		// 每隔5秒执行一次轮询函数
		this.intervalId = setInterval(this.messageData, 5000);

	}

	componentWillReceiveProps(nextProps) {
		let { activeKey, openKey } = this.state;

		console.log(nextProps, 'nextProps----');

		let menuItems = this.buildMenuItems(nextProps.leftNode);

		let nextPath = nextProps.location.pathname && nextProps.location.pathname.slice(6).split(',');

		if (nextProps.leftActiveKey !== activeKey) {
			openKey = [];

			activeKey = nextProps.leftActiveKey;

			this.findOpenKey(openKey, nextProps.leftNode, nextProps.leftActiveKey);
		}

		activeKey = activeKey || nextPath;

		this.buildOpenKey(openKey, nextProps.leftNode, activeKey)

		this.setState({ menuItems: menuItems, activeKey: activeKey, openKey: openKey });
	}
	componentWillUnmount() {
		clearInterval(this.intervalId);
		EventBus.off('bodyDataChanged', this.handleBodyDataChange);
	}


	handleBodyDataChange = () => {
		this.messageData();
	}



	render() {
		let { activeKey, openKey, isState, menuItems, MessageTotal, info } = this.state;
		const { collapsed } = this.props;
		return (
			<div className="sf-left sd-left sg-left">
				{/* <div className="sf-system-title sd-system-title sg-system-title">
					兰创鸿智人才服务平台
				</div> */}
				<div className="sf-left-bg sd-left-bg sg-left-bg">
					<Menu
						defaultSelectedKeys={activeKey}
						defaultOpenKeys={openKey}
						selectedKeys={activeKey}
						openKeys={openKey}
						mode="inline"
						theme="light"
						inlineCollapsed={collapsed}
						onOpenChange={(value, e) => this.handleOpenChange(value, e)}
						onSelect={this.handleSelect}
						onClick={this.handleClick}
					>
						{
							menuItems && menuItems.length > 0 ?
								menuItems.map((item) => {

									return <Menu.Item key={item.key} onClick={() => this.handleClick(item, item.key, item.path)}>
										{
											item?.icon ?
												<img src={require(`../img/frame/leftIcon/${item.icon}.svg`)} /> : <></>
										}
										{item.title}
										{item?.name == 'enterprise_home' && info?.EIC != 1 ? <div className='sf-left-MenuPerfect'>待完善</div> : <></>}
										{item?.name == 'message_manager' && MessageTotal > 0 ? <div className='sf-left-MenuPerfect'>{MessageTotal}</div> : <></>}
									</Menu.Item>

								})
								: <></>
						}
					</Menu>
				</div>
			</div>
		);
	}
}

export default Left